/* VIDEO AS SECOND CARD MEDIA RULE — hover toca o vídeo da 2ª mídia.
   • Só em dispositivo com hover real e ponteiro fino (desktop/notebook).
     Toque/tablet/mobile: nada é baixado nem tocado; a imagem principal
     continua padrão e o poster é a 2ª mídia estática.
   • prefers-reduced-motion: não toca; o hover mostra só o poster.
   • Nada no first paint: o src sai de data-src no primeiro hover.
   • mouseleave / saída da viewport: pausa e volta ao início; a imagem
     principal reaparece pelo CSS (classe is-video-on sai).
   • O <video> fica dentro do link da imagem com pointer-events:none, então
     clique no card, coração, badges, swatches, quick add e CTA seguem iguais.
   Carregado uma vez no theme.liquid. Delegação no document com guard:
   sobrevive a shopify:section:load, carrosséis e grades por AJAX. */
(function () {
  if (window.__aipCardVideoInit) return;
  window.__aipCardVideoInit = true;

  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqCalmo = window.matchMedia('(prefers-reduced-motion: reduce)');

  function podeTocar() { return mqHover.matches && !mqCalmo.matches; }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) parar(e.target); });
  }, { threshold: 0 }) : null;

  function parar(v) {
    var wrap = v.closest('.product-card-2026__image-wrapper');
    if (wrap) wrap.classList.remove('is-video-on');
    if (!v.paused) v.pause();
    try { if (v.currentTime) v.currentTime = 0; } catch (err) {}
  }

  /* O Liquid só expõe o MP4 1080p (7,2 Mbps). O JSON do produto lista todas
     as renditions; o card usa a mais leve com pelo menos 480px (~1,5 Mbps).
     Uma requisição por produto, só no 1º hover, com cache em memória.
     Qualquer falha cai no data-src do Liquid. */
  var cacheFonte = {};
  function fonteLeve(v) {
    var url = v.dataset.p26Json, id = v.dataset.p26Media;
    if (!url || !id || !window.fetch) return Promise.resolve(v.dataset.src);
    if (!cacheFonte[url]) {
      cacheFonte[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cacheFonte[url].then(function (p) {
      var m = p && (p.media || []).filter(function (x) { return String(x.id) === String(id); })[0];
      var mp4 = m && (m.sources || []).filter(function (s) { return s.format === 'mp4' && s.url; })
        .sort(function (x, y) { return (x.height || 0) - (y.height || 0); });
      if (!mp4 || !mp4.length) return v.dataset.src;
      var leve = mp4.filter(function (s) { return (s.height || 0) >= 480; })[0] || mp4[mp4.length - 1];
      return leve.url;
    });
  }

  function iniciar(wrap, v) {
    if (!wrap.__aipHover) return;
    v.muted = true;
    if (!v.__aipPronto) {
      v.__aipPronto = true;
      v.addEventListener('playing', function () {
        if (wrap.__aipHover) wrap.classList.add('is-video-on');
      });
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () { wrap.classList.remove('is-video-on'); });
  }

  function tocar(wrap) {
    if (!podeTocar()) return;
    var v = wrap.querySelector('video[data-p26-video]');
    if (!v) return;
    wrap.__aipHover = true;
    if (v.getAttribute('src')) { iniciar(wrap, v); return; }
    if (v.__aipCarregando) return;
    v.__aipCarregando = true;
    fonteLeve(v).then(function (src) {
      v.__aipCarregando = false;
      if (!src) return;
      v.setAttribute('src', src);
      v.setAttribute('preload', 'auto');
      if (io) io.observe(v);
      iniciar(wrap, v);
    });
  }

  document.addEventListener('mouseover', function (e) {
    var wrap = e.target.closest && e.target.closest('.product-card-2026__image-wrapper');
    if (!wrap || wrap.__aipHover) return;
    if (!wrap.querySelector('video[data-p26-video]')) return;
    tocar(wrap);
  });

  document.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest && e.target.closest('.product-card-2026__image-wrapper');
    if (!wrap || !wrap.__aipHover) return;
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    wrap.__aipHover = false;
    var v = wrap.querySelector('video[data-p26-video]');
    if (v) parar(v);
  });

  /* aba em segundo plano: nada tocando escondido */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    document.querySelectorAll('video[data-p26-video]').forEach(parar);
  });
})();
